
import { Vue } from "vue-class-component";
import { setup } from "@cems-eco/core/src/utils/white-label";
import { GlobalThemeOverrides, NConfigProvider } from 'naive-ui';
import guard from "@/guard";
import environment from "@/config";

export default class App extends Vue {
  default = "main";

  themeOverrides: GlobalThemeOverrides = environment.white_label.naiveui;
  template: string = environment.white_label.template;

  get layout() {
    return (this.$route.meta.layout || this.default) + "-layout";
  }

  async created() {
    setup();
    await guard.checkProviderStatus();
  }
}
